import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { Spin } from "antd";
import { CarOutlined } from "@ant-design/icons";
import { getDrivers } from "../../Drivers/services/driverApi";
import { useTranslation } from "react-i18next";
import { Row, Col } from "reactstrap";
import axios from "axios";
import { FilePond, registerPlugin } from "react-filepond";
import { FilePondPluginImagePreview } from "filepond-plugin-image-preview";
import "filepond/dist/filepond.min.css";
import { uploadImage } from "../../Media/services/mediaApi";
import "filepond/dist/filepond.min.css";
import { useNavigate } from "react-router-dom";
import { Steps } from "antd";
import { createVehicule } from "../../Vehicules/services/vehiculeApi";
import { getStatus } from "../../Status/services/statusApi";
const { Step } = Steps;

const AddEditRappelForm = ({ modal, setModal, toggle, selectedVehicule }) => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [isLoadingSubmit, setisLoadingSubmit] = useState(false);
  const [imageFile, setImageFile] = useState(null); // Pour stocker l'image sélectionnée
  const {
    isLoading: isLoadingDrivers,
    isError: isErrorDrivers,
    error: errorDrivers,
    data: drivers,
  } = useQuery("drivers", getDrivers);
  const {
    isLoading: isLoadingStatus,
    isError: isErrorStatus,
    error: errorStatus,
    data: status,
  } = useQuery("status", getStatus);
  const category = "Véhicule";
  const [image, setImage] = useState(null);

  const handlePhotoFileUpdate = (fileItems) => {
    setImage(fileItems.length > 0 ? fileItems[0].file : null);
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Récupère le premier fichier sélectionné
    console.log("Fichier sélectionné:", file); // Vérifie le fichier sélectionné

    if (file && file instanceof File) {
      handlePhotoFileUpdate(file);
    } else {
      console.error("Le fichier sélectionné n'est pas valide ou est manquant");
      toast.error("Veuillez sélectionner un fichier valide");
    }
  };

  const handleImageDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      handlePhotoFileUpdate([{ file }]);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };
  const [isLoading, setIsLoading] = useState(false);
  const [isFileSelected, setIsFileSelected] = useState(false);
  const validationSchema = Yup.object().shape({
    registrationNumber: Yup.string().required(
      t("vehicleForm.registrationNumber")
    ),
    model: Yup.string().required(t("vehicleForm.model")),
    commissioningDate: Yup.date().required(t("vehicleForm.commissioningDate")),
    actualUserId: Yup.number().required(t("vehicleForm.actualDriver")),
    mileage: Yup.number().required(t("vehicleForm.mileage")),
    status: Yup.string().required(t("vehicleForm.statut")),
    name: Yup.string().required(t("vehicleForm.name")),
    description: Yup.string(t("vehicleForm.description")),
    transmissin: Yup.string(t("vehicleForm.transmission")),
    speed: Yup.number(t("vehicleForm.speed")),
    vin: Yup.string(t("vehicleForm.vin")),
    color: Yup.string(t("vehicleForm.color")),
  });
  const initialValues = selectedVehicule
    ? {
        registrationNumber: selectedVehicule.registrationNumber,
        model: selectedVehicule.model,
        commissioningDate: selectedVehicule.commissioningDate,
        actualUserId: selectedVehicule.actualUserId,
        mileage: selectedVehicule.mileage,
        status: selectedVehicule.status,
        name: selectedVehicule.name,
        description: selectedVehicule.description,
        transmission: selectedVehicule.transmission,
        speed: selectedVehicule.speed,
        vin: selectedVehicule.vin,
        color: selectedVehicule.color,
        fileName: selectedVehicule.fileName || "",
      }
    : {
        registrationNumber: "",
        model: "",
        commissioningDate: "",
        actualUserId: "",
        mileage: "",
        status: "",
        fileName: "",
        name: "",
        description: "",
        transmission: "",
        speed: "",
        vin: "",
        color: "",
      };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setisLoadingSubmit(true);
      try {
        let fileName = values.fileName;
        if (image) {
          const response = await uploadImage(category, image);
          fileName = response?.name;
        }
        const payload = {
          registrationNumber: values.registrationNumber,
          model: values.model,
          commissioningDate: values.commissioningDate,
          actualUserId: parseInt(values.actualUserId),
          mileage: values.mileage,
          status: values.status,
          name: values.name,
          description: values.description,
          transmission: values.transmission,
          speed: values.speed,
          vin: values.vin,
          fileName: fileName,
        };

        if (selectedVehicule) {
          await updateVehicule(selectedVehicule?.id, payload);
          toast.success(t("vehicleForm.successEdit"));
        } else {
          await createVehicule(payload);
          toast.success(t("vehicleForm.successAdd"));
        }

        await queryClient.invalidateQueries("vehicules");
        toggle();
        formik.resetForm();
      } catch (error) {
        toast.error(t("vehicleForm.error"), error?.message || error);
      } finally {
        setisLoadingSubmit(false);
      }
    },
  });

  const handlePrevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };
  useEffect(() => {
    formik.setValues(initialValues);
  }, [selectedVehicule]);

  const modalTitle = selectedVehicule
    ? t("rappels.edit_R")
    : t("rappels.add_R");

  return (
    <div className="" style={{ borderRadius: "8px" }}>
      <Modal
        id="showModalClient"
        isOpen={modal}
        toggle={toggle}
        centered
        backdrop={"static"}
        style={{
          maxWidth: "440px",
          maxHeight: "593px",
        }}
      >
        <Row></Row>
        <Form onSubmit={formik.handleSubmit}>
          <ModalBody className="modal-body">
            <div
              className="text-center"
              style={{
                color: "#252525",
                fontFamily: "Raleway",
                fontSize: "22px",
                fontWeight: "bold",
              }}
            >
              {modalTitle}
            </div>
            <Row className="">
              <Col md={12}>
                <div className="">
                  <label
                    htmlFor="titre"
                    className="form-label"
                    style={{
                      color: "#6C6B6B",
                      fontFamily: "Inter",
                      fontWeight: "400px",
                      size: "14px",
                    }}
                  >
                    {t("rappels.titre")}
                  </label>
                  <input
                    type="text"
                    id="titre"
                    name="titre"
                    className="form-control"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.titre}
                    style={{
                      border: "1px solid #D9D9D9",
                    }}
                  />
                  {formik.touched.titre && formik.errors.titre && (
                    <div className="text-danger">{formik.errors.titre}</div>
                  )}
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col md={6}>
                <div className="mb-3">
                  <label
                    htmlFor="date"
                    className="form-label"
                    style={{
                      color: "#6C6B6B",
                      fontFamily: "Inter",
                      fontWeight: "400",
                      fontSize: "14px",
                    }}
                  >
                    {t("rappels.date")}
                  </label>
                  <input
                    type="date"
                    id="date"
                    name="date"
                    className="form-control"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.date}
                    style={{
                      border: "1px solid #D9D9D9",
                    }}
                  />
                  {formik.touched.date && formik.errors.date && (
                    <div className="text-danger">{formik.errors.date}</div>
                  )}
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <label
                    htmlFor="time"
                    className="form-label"
                    style={{
                      color: "#6C6B6B",
                      fontFamily: "Inter",
                      fontWeight: "400",
                      fontSize: "14px",
                    }}
                  >
                    {t("rappels.time")}
                  </label>
                  <input
                    type="time"
                    id="time"
                    name="time"
                    className="form-control"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.time}
                    style={{
                      border: "1px solid #D9D9D9",
                    }}
                  />
                  {formik.touched.time && formik.errors.time && (
                    <div className="text-danger">{formik.errors.time}</div>
                  )}
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={12}>
                <div className="mb-3">
                  <label
                    htmlFor="description"
                    className="form-label"
                    style={{
                      color: "#6C6B6B",
                      fontFamily: "Inter",
                      fontWeight: "400px",
                      size: "14px",
                    }}
                  >
                    {t("types.description")}
                  </label>
                  <textarea
                    id="description"
                    name="description"
                    className="form-control"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.description}
                    rows="4"
                    style={{
                      border: "1px solid #D9D9D9",
                    }}
                  />
                  {formik.touched.description && formik.errors.description && (
                    <div className="text-danger">
                      {formik.errors.description}
                    </div>
                  )}
                </div>
              </Col>
            </Row>

            <div className=" center ">
              <Button
                type="submit"
                className="bordered-btn"
                disabled={isLoading}
              >
                {isLoadingSubmit ? (
                  <Spin size="small" />
                ) : selectedVehicule ? (
                  t("rappels.edit")
                ) : (
                  t("rappels.add")
                )}
              </Button>
              <Button
                className="bordered-btn-light"
                color="light"
                onClick={() => setModal(false)}
              >
                {t("driverForm.cancel")}
              </Button>
            </div>
          </ModalBody>
        </Form>
      </Modal>
    </div>
  );
};
export default AddEditRappelForm;
